import { render, staticRenderFns } from "./ProjectActivityTask.vue?vue&type=template&id=49436400&"
import script from "./ProjectActivityTask.vue?vue&type=script&lang=js&"
export * from "./ProjectActivityTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports